export default class Section {
    key;
    title;
    description;
    subSections;
    settingList;
    component;

    constructor({ key, title, description, subSections, settingList, component }) {
        this.key = key;
        this.title = title;
        this.description = description;
        this.subSections = subSections;
        this.settingList = settingList;
        this.component = component;
    }

    getFlatSettingList() {
        return [
            ...(this.settingList || []),
            ...(this.subSections?.flatMap(s => s.getFlatSettingList()) || [])
        ];
    }
}